import FormModal from "../components/form/FormModal";
import {JsonTemplate} from "../generated-api";
import {FormProps} from "../model/form";
import {useAppTranslation} from "../services/i18n";
import EventTemplateForm from "../components/event/EventTemplateForm";
import {TEMPLATE_TYPE_INVITE} from "../model/template";

const EventTemplateModal = (props: FormProps<JsonTemplate>) => {

    const t = useAppTranslation();

    return (
        <FormModal title={props.item?.templateType === TEMPLATE_TYPE_INVITE ? t('Úprava textu') : t('Úprava e-mailu')} {...props} maxWidth={'xl'}>
            <EventTemplateForm {...props}></EventTemplateForm>
        </FormModal>
    );
}

export default EventTemplateModal;
